import { addSizeToImageSrc } from 'shared/utils/imageUtils'

type ImageUrlProductArg = {
  image?: string
  prescriptionMedicine: boolean
}

const getImageUrl = ({
  product,
  cdnUrl,
  width,
  isRebrandingEnabled,
  placeholderFromCdn,
}: {
  product: ImageUrlProductArg
  cdnUrl: string
  width?: number
  isRebrandingEnabled?: boolean
  placeholderFromCdn?: boolean
}): string => {
  let imageUrl = product.image

  const placeholderImageUrl = `${
    placeholderFromCdn ? cdnUrl : 'https://static.shop-apotheke.com'
  }/media/content/placeholder.png`

  const placeholderImageUrlRebranding = `${
    placeholderFromCdn ? cdnUrl : 'https://static.redcare.it'
  }/media/landingpages/placeholder-rebranding.png`

  const placeholderImagePrescriptionUrl = `${
    placeholderFromCdn ? cdnUrl : 'https://static.shop-apotheke.com'
  }/media/content/placeholder-prescription-ad.png`

  if (!imageUrl) {
    const placeholderUrl = isRebrandingEnabled
      ? placeholderImageUrlRebranding
      : placeholderImageUrl
    imageUrl = product.prescriptionMedicine
      ? placeholderImagePrescriptionUrl
      : placeholderUrl
  }

  if (!width && width !== 0) {
    return imageUrl
  }

  return addSizeToImageSrc({
    src: imageUrl,
    width,
    cdnUrl,
  })
}

export default getImageUrl
